var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/free_product_icon.f18d5a5d.png","uri@2x": __webpack_public_path__ + "static/media/free_product_icon.51e10ad6.png","uri@3x": __webpack_public_path__ + "static/media/free_product_icon.0de7d932.png",
    width: 9,
    height: 9
});